import * as React from 'react';
import { FormSelect } from '@gulfwinds/ui-components';
import { emptyArray } from 'src/shared/helpers/utils';

const DropdownFilterCell = ({ defaultItem, value, data = emptyArray, onChange }) => {
  let hasValue = (value) => Boolean(value && value !== defaultItem);

  const handleChange = (event) => {
    hasValue = hasValue(event.target.value);
    onChange({
      value: hasValue ? event.target.value.text : '',
      operator: hasValue ? 'eq' : '',
      syntheticEvent: event.syntheticEvent,
    });
  };

  return (
    <div className='k-filtercell'>
      <FormSelect
        data={data.map((item) => ({ text: item, value: item }))}
        keysOnly
        onChange={handleChange}
        value={value || defaultItem}
        defaultItem={defaultItem}
        textField='text'
        dataItemKey='value'
      />
    </div>
  );
};

export default DropdownFilterCell;
